export default "__VITE_ASSET__C9bNWNen__"